export default __webpack_public_path__ + "static/media/AppointmentSharing.bfe0b63d.png";